import React from 'react';

// Lightweight CSS-driven particle field. Cyan dots floating upward with subtle glow.
// Pure CSS animations — no JS frame loop = excellent performance.
const ParticlesBg = ({ count = 40, className = '' }) => {
  const [particles] = React.useState(() => {
    return Array.from({ length: count }).map((_, i) => {
      const size = Math.random() * 4 + 1.5; // 1.5 - 5.5px
      const left = Math.random() * 100;
      const delay = Math.random() * 20;
      const duration = Math.random() * 18 + 12; // 12 - 30s
      const opacity = Math.random() * 0.5 + 0.2;
      return { size, left, delay, duration, opacity, id: i };
    });
  });

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden>
      {particles.map((p) => (
        <span
          key={p.id}
          className="particle"
          style={{
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            opacity: p.opacity,
          }}
        />
      ))}
    </div>
  );
};

export default ParticlesBg;
